import { useMemo } from 'react';

import { levelSelectAll } from '@/Module/Grade/Store/Selector';
import { useAppSelector } from '@/Module/Store/Hook';

export const usePrepareMenuData = () => {
  const data = useAppSelector(levelSelectAll);
  return useMemo(() => {
    return {
      dataLesson: data.length ? data.slice(0, 3) : [],
      dataExam: data.length ? data.slice(3, 7) : [],
    };
  }, [data]);
};
